/**
 * useIsNarrow — узкий экран (телефон) через matchMedia.
 *
 * Зачем хук, а не CSS: вёрстка в проекте на инлайн-стилях, а они медиазапросы
 * не умеют. Там, где на телефоне нужна не «та же строка поменьше», а другая
 * раскладка (например позиция начисления складывается в две строки), выбор
 * приходится делать в JS.
 *
 * Дефолт 640px: планшет (768) шире и в одну строку ещё помещается.
 */
import { useState, useEffect } from 'react';

export default function useIsNarrow(maxWidth = 640) {
  const query = `(max-width: ${maxWidth}px)`;
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const h = (e) => setNarrow(e.matches);
    setNarrow(mq.matches);            // ширина могла измениться до подписки
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, [query]);

  return narrow;
}
